// Import API request handler
import { request } from "../api/api";

// Chat Related APIs

// Create or open chat room for user
export const openRoom = (userId) => {
  return request.post("/chat/open", { user_id: userId });
};

// Send message with optional attachments
export const sendMessage = (formData) => {
  return request.post("/chat/message", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// Get paginated chat messages for a room
export const getMessagesByRoomId = (roomId, page) => {
  return request.post(`chat/room/message?page=${page}`, { room_id: roomId });
};

// Subscription Related APIs

// Get list of available subscription plans
export const getSubscriptionList = () => {
  return request.get("/subscription");
};

// Chat Status APIs

// Mark messages as seen in chat room
export const updateSeenStatus = (data, room_id) => {
  return request.post(`/chat/room/status/${room_id}`, data);
};

// Add emoji reaction to chat message
export const addEmojiReactionToMessage = (data, message_id) => {
  return request.post(`/chat/room/reaction/${message_id}`, data);
};

// Payment Related APIs

// Initialize Stripe payment session
export const createStripeCheckoutSession = (data) => {
  return request.post("/stripe/checkout-session", data);
};

// Get user's current subscription info
export const getSubscriptionDetails = () => {
  return request.get(`/my/subscriptions`);
};

// Get user's invoice history
export const getInvoiceDetails = (userID) => {
  return request.get(`/invoices/${userID}`);
};

// Cancel user's current subscription
export const cancelMySubscription = () => {
  return request.post("/my/subscriptions/cancel", {});
};

// Chat Message Management

// Remove a message from chat
export const deleteMessage = (messageID) => {
  return request.post(`/chat/messages/delete/${messageID}`);
};

// App Configuration

// Fetch application global settings
export const getGlobalSettingsData = () => {
  return request.get("/global-settings");
};

// Onboarding Related APIs

// Get onboarding questionnaire flow
export const getOnboardingFlow = () => {
  return request.get("/questionnaires/flow");
};

// Save user's onboarding responses
export const submitOnboardingAnswers = (payload) => {
  return request.post("/client-onboarding/answers", payload);
};

// See my plan will onboarding answers 
export const seeMyPlan = (payload) => {
  return request.post("/client-onboarding/see-my-plan", payload);
}

// Get user's previous onboarding answers
export const getUserOnboardingAnswers = async (userId) => {
  try {
    const response = await request.get(`/client-onboarding/answers/${userId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Update existing onboarding answers
export const updateOnboardingAnswers = async (userId, payload) => {
  try {
    const response = await request.put(`/client-onboarding/answers/${userId}`, payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// User Profile Management

// Get user profile details
export const getUserProfile = async (userId)  => {
  return request.get(`/user-profile/${userId}`);
}

// Update user profile with form data
export const updateUserProfile = async (userId, formData) => {
  return request.post(`/user-profile/${userId}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
